import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import { ID_PERFIL_ADMIN_EMPRESA, ID_PERFIL_ADMIN_EBP } from '../../constants/perfiles'
import Categorias from '../categorias/Categorias'
import ContenedorCategorias from '../categorias/ContenedorCategorias'
import Subcategorias from '../categorias/Subcategorias'
import Contacto from '../contacto/Contacto'
import Favoritos from '../favoritos/Favoritos'
import RutaProtegidaPorPerfil from '../hoc/RutaProtegidaPorPerfil'
import Notificaciones from '../notificaciones/Notificaciones'
import PublicacionDetalle from '../pages/PublicacionDetalle'
import Domicilios from '../perfil/Domicilios'
import Password from '../perfil/Password'
import Perfil from '../perfil/Perfil'
import DetallePresupuesto from '../presupuestos/DetallePresupuesto'
import Publicaciones from '../publicaciones/Publicaciones'
import PedidoDetalle from '../reutilizables/pedidos/PedidoDetalle'
import PedidoItemDetalle from '../reutilizables/pedidos/PedidoItemDetalle'
import Scraps from '../scraps/Scraps'
import TiendasOficiales from '../tiendasoficiales/TiendasOficiales'
import AdministracionUsuarios from '../usuarios/AdministracionUsuarios'

const protegerAdmin = (element) => (
  <RutaProtegidaPorPerfil perfilesPermitidos={[ID_PERFIL_ADMIN_EMPRESA, ID_PERFIL_ADMIN_EBP]}>
    {element}
  </RutaProtegidaPorPerfil>
)

const ComunesRoutes = (props) => (
  <>
    <Route path="/Favoritos" element={<Favoritos />} />
    <Route path="/Publicaciones/TiendasOficiales/:idVendedor" element={<Publicaciones />} />
    <Route path="/Publicaciones/Subcategorias/:idSubCategoria" element={<Publicaciones />} />
    <Route path="/Publicaciones/Detalle/:idPublicacion" element={<Publicaciones />} />
    <Route path="/Publicaciones" element={<Publicaciones />} />
    <Route path="/Publicacion/:id" element={<PublicacionDetalle />} />
    <Route path="/PublicacionesOfertas" element={<Publicaciones ofertas="S" />} />
    <Route path="/TiendasOficiales" element={<TiendasOficiales />} />
    <Route path="/Categorias" element={<ContenedorCategorias />} />
    <Route path="/Categorias/:categoria" element={<Categorias />} />
    <Route path="/Subcategorias/:idCategoria/:descripcion" element={<Subcategorias />} />
    <Route path="/Perfil" element={<Perfil cambiarImagenPerfil={props.cambiarImagenPerfil} />} />
    <Route path="/AdministrarDomicilios" element={<Domicilios />} />
    <Route path="/Password" element={<Password />} />
    <Route path="/Contacto" element={<Contacto />} />
    <Route path="/Colaboradores" element={protegerAdmin(<AdministracionUsuarios />)} />
    <Route path="/Notificaciones" element={<Notificaciones />} />
    <Route path="/Scraps" element={<Scraps />} />
    <Route path="/Presupuesto/:idPresupuesto" element={<DetallePresupuesto />} />
    <Route path="/PedidoItem/:idPedidoItem" element={<PedidoItemDetalle />} />
    <Route path="/Pedido/:idPedido" element={<PedidoDetalle />} />
  </>
)

ComunesRoutes.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default ComunesRoutes
